export default __webpack_public_path__ + "static/media/8d.c96430fb.png";